export default __webpack_public_path__ + "static/media/Lato-Bold.ada060dc.woff2";